import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  submitted = false
  username = ""

  constructor(private util: UtilService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
  }

  async checkUsername() {
    this.submitted = true
    if (this.username.trim() != "") {
      this.util.ShowWaiting(true)
      this.submitted = false
      let para = "username=" + this.username
      let user: any = await this.apiService.get("crmservice", "callcenterProfile", para)

      if (user != null && user.length > 0) {
        if (user[0].dpa_customwebuserid != null && user[0].dpa_customwebuserid.toString().trim().length != 0) {
          let req: any = {
            username: this.username,
            email: user[0].dpa_emailaddress,
            call_by: "1",
            url: this.util.baseUrl(),
            userid: user[0].dpa_customwebuserid
          }
          let res: any = await this.apiService.postCustom("Crm", "ResetCallCenterPassword", req)
          if (this.util.isSuccessResponse(res)) {
            // let emailRes: any = await this.SendEmail(res, user[0].dpa_emailaddress)

            // if (this.util.isSuccessResponse(emailRes)) {
              this.util.SuccessDialog("ระบบได้ส่ง email สำหรับกำหนดรหัสผ่านใหม่ไปยัง email ของท่านแล้ว")
            // }
            // else {
            //   this.util.ErrorDialog("ส่ง email กำหนดรหัสผ่านใหม่ไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่")
            // }
          }
          else {
            this.util.ErrorDialog("ไม่สามารถส่ง email กำหนดรหัสผ่านใหม่ได้ กรุณาติดต่อเจ้าหน้าที่")
          }
        }
        else {
          this.util.ErrorDialog("ไม่พบ email ของ user ที่ท่านกรอก")
        }
      }
      else {
        this.util.ErrorDialog("ไม่พบ user ที่ท่านกรอก")
      }

      this.util.ShowWaiting(false)
    }
  }

  // async SendEmail(token: any, email: string) {
  //   let MailObj: any = {
  //     dpa_name: "ท่านได้ร้องขอการกำหนดรหัสผ่านใหม่",
  //     dpa_emailaddress: email
  //   };
  //   let url = this.util.baseUrl() + "/setNewPassword?id=" + token
  //   var MailContent = "   โปรดคลิกลิงค์ด้านล่างเพื่อกำหนดรหัสผ่านใหม่ <br /><br />" +
  //     '<a target="_blank" href="' + url + '">' + url + "</a><br /><br />" +
  //     "ขอแสดงความนับถือ <br />" +
  //     "สถาบันคุ้มครองเงินฝาก <br />" +
  //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
  //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
  //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
  //     "โทร : 02-272-0300";
  //   MailObj.dpa_description = MailContent;
  //   MailObj.dpa_callby = 1
  //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
  //   return Res;
  // }

  close() {
    window.close()
  }

}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts